'use client';

import './volunteer-no-events.scss';

import { useTranslation } from 'react-i18next';

import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { absoluteUrlFromPath, knownSkippyUrls } from '@sola/skippy-sdk/urls.ts';

export const VolunteerNoEvents = () => {
  const { t } = useTranslation('volunteers');

  return (
    <div className="VolunteerNoEvents max-w-sm flex w-full flex-col items-center gap-comfy-xs overflow-hidden px-comfy-lg py-comfy-md">
      <span className="VolunteerNoEvents__avatar flex shrink-0 items-center justify-center rounded-full">
        <ArkIcon iconName="volunteer" size="1.75rem" alt="" />
      </span>
      <div className="flex w-full flex-col items-center gap-snug-lg text-center">
        <span className="label-potent label-lg">
          {t('volunteers:myEvents.noEventsTitle')}
        </span>
        <span className="label-moderate label-lg label-neutral-mild">
          {t('volunteers:myEvents.noEventsBody')}
        </span>
      </div>
      <ButtonStyle variant="secondary" size="md">
        <Link
          className="VolunteerNoEvents__cta"
          href={absoluteUrlFromPath(knownSkippyUrls.volunteers)}
        >
          {t('volunteers:myEvents.viewAllEvents')}
        </Link>
      </ButtonStyle>
    </div>
  );
};
